import {getCurrentYear} from '../../utils/commons'
import HouseholdBestPicksLogo from './logo'
import {householdBestPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'householdbestpicks' as const,
  domainType: 'picks' as const,
  siteName: 'Household Best Picks',
  logo: <HouseholdBestPicksLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/householdbestpicks.png',
  styles: householdBestPicksStylesUS,
}

const localeConfigs = {
  us: {
    measurementId: 'G-44CCKGY36Y',
    camelCaseUrl: 'HouseholdBestPicks.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | HouseholdBestPicks.com – Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `At HouseholdBestPicks.com, we showcase the finest household essentials for ${getCurrentYear()}. Benefit from our expert reviews and detailed product insights`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
